import type { GridRenderCellParams, SearchSearchColumnDef } from '@/components/custom/erp';
import { formatDate, formatMoney, roundNumber } from '@/lib/formatUtils';
import { DateSearchSelect } from '@/components/custom/erp';
import type { GiaMua } from '@/types/schemas';

export const getDataTableColumns = (handleViewClick: (row: GiaMua) => void): SearchSearchColumnDef<GiaMua>[] => [
  {
    field: 'ma_vt',
    headerName: 'Mã vật tư',
    width: 120,
    renderCell: (params: GridRenderCellParams<GiaMua>) => (
      <button
        onClick={e => {
          e.stopPropagation();
          handleViewClick(params.row);
        }}
        className='cursor-pointer hover:text-blue-500 hover:underline'
      >
        {params.row.ma_vt_data?.ma_vt || params.row.ma_vt}
      </button>
    )
  },
  {
    field: 'ten_vt',
    headerName: 'Tên vật tư',
    width: 200,
    renderCell: (params: GridRenderCellParams<GiaMua>) => params.row.ma_vt_data?.ten_vt || params.row.ten_vt
  },
  {
    field: 'dvt',
    headerName: 'Đơn vị tính',
    width: 100,
    renderCell: (params: GridRenderCellParams<GiaMua>) => params.row.dvt_data?.dvt || params.row.dvt
  },
  {
    field: 'ngay_hl',
    headerName: 'Ngày hiệu lực',
    width: 120,
    renderCell: params => formatDate(params.value),
    renderSearchInput: params => <DateSearchSelect {...params} />
  },
  {
    field: 'ma_kh',
    headerName: 'Nhà cung cấp',
    width: 150,
    renderCell: (params: GridRenderCellParams<GiaMua>) => params.row.ma_kh_data?.customer_code || params.row.ma_kh
  },
  {
    field: 'ten_kh',
    headerName: 'Tên khách hàng',
    width: 150,
    renderCell: (params: GridRenderCellParams<GiaMua>) => params.row.ma_kh_data?.customer_name || params.row.ten_kh
  },
  {
    field: 'sl_tu',
    headerName: 'Số lượng từ',
    width: 120,
    type: 'number',
    align: 'right',
    renderCell: params => roundNumber(params.value, 4)
  },
  {
    field: 'gia_nt',
    headerName: 'Giá',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(params.value),
    align: 'right'
  },
  {
    field: 'ma_nt',
    headerName: 'Ngoại tệ',
    width: 100,
    renderCell: (params: GridRenderCellParams<GiaMua>) => params.row.ma_nt_data?.ma_nt || params.row.ma_nt,
    align: 'center'
  }
];
